<template>
    <my-dialog title="销售订单详情" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
        @close="closeDialog" width="80%">
        <detail ref="detail"></detail>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog">关闭</el-button>
        </div>
    </my-dialog>
</template>
<script>
import detail from "@/views/product/sales/detail.vue";
export default {
    props: [],
    data() {
        return {
            showDialog: false,
        };
    },
    components: {
        detail,
    },
    created() { },
    methods: {
        // 显示
        getDetailDialog(row) {
            this.showDialog = true;
            this.$nextTick(() => {
                this.$refs.detail.getDetail(row);
            })
        },
        // 关闭
        closeDialog() {
            this.showDialog = false;
        },
    },
};
</script>
<style scoped lang="scss"></style>